import React, { useContext } from "react"
import * as s from "./index.module.less"
import { SpaceProfileContext } from "../../context"
import formatPrice from "../../../../utils/formatPrice"

const LinkToReservationStep = () => {
  const {
    commonData: {
      optionTotal,
      isDaily,
      days,
      optionPrice,
      optionValue,
      hstPercentage,
      optionHstValue,
    },
    actions: { setValue },
  } = useContext(SpaceProfileContext)

  return (
    <>
      <ul className={s.results_list}>
        <li>
          <span>
            ${optionPrice} x {days} {isDaily ? "day" : "hour"}
            {days === 1 ? "" : "s"}
          </span>
          <span>{formatPrice(optionValue)}</span>
        </li>
        <li>
          <span>HST ({hstPercentage * 100}%)</span>
          <span>{formatPrice(optionHstValue)}</span>
        </li>
        <li>
          <span>Total</span>
          <span>{formatPrice(optionTotal)}</span>
        </li>
      </ul>
      <ul>
        <li>No charges until your booking begins</li>
      </ul>
      <button
        className="btn btn-primary mt-4 w-100"
        onClick={() => setValue({ showPerDayBooking: true })}
      >
        Reserve
      </button>
    </>
  )
}

export default LinkToReservationStep
